import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Linkedin,
  Instagram,
  Youtube,
  ArrowRight,
} from "lucide-react";
import { FaPinterest } from "react-icons/fa";
import { Link } from "react-router-dom";

function FooterFr({ removeTopGap = false }) {
  const lifeLinks = [
    { label: "Assurance vie", to: "/fr/assurance-vie" },
    { label: "Assurance vie temporaire", to: "/fr/assurance-vie-temporaire" },
    { label: "Assurance vie permanente", to: "/fr/assurance-vie-permanente" },
    { label: "Assurance vie entière", to: "/fr/assurance-vie-entiere" },
    { label: "Assurance hypothécaire", to: "/fr/assurance-hypothecaire" },
    { label: "Assurance vie universelle", to: "/fr/assurance-vie-universelle" },
    { label: "Assurance sans examen médical", to: "/fr/assurance-sans-examen-medical" },
    { label: "Assurance enfants", to: "/fr/assurance-enfants" },
    { label: "Assurance maladie", to: "/fr/assurance-maladie" },
    { label: "Assurance nouveaux arrivants", to: "/fr/assurance-nouveaux-arrivants" },
  ];

  const investmentLinks = [
    { label: "Compte d'épargne libre d'impôt pour l'achat d'une première propriété", to: "/fr/compte-epargne-premier-logement" },
    { label: "Compte d'épargne libre d'impôt", to: "/fr/compte-epargne-libre-impot" },
    { label: "Régime enregistré d'épargne-études", to: "/fr/regime-epargne-etudes" },
    { label: "Régimes enregistrés d'épargne-retraite", to: "/fr/regime-epargne-retraite" },
    { label: "Régime enregistré d'épargne-invalidité", to: "/fr/regime-epargne-invalidite" },
  ];

  const travelLinks = [
    { label: "Assurance voyage", to: "/fr/assurance-voyage" },
    { label: "Assurance visiteurs au Canada", to: "/fr/assurance-visiteurs-canada" },
    { label: "Assurance super visa", to: "/fr/assurance-super-visa" },
    { label: "Assurance étudiant international", to: "/fr/assurance-etudiants-internationaux" },
  ];

  const livingLinks = [
    { label: "Assurance maladies graves", to: "/fr/assurance-maladies-graves" },
    { label: "Assurance invalidité", to: "/fr/assurance-invalidite" },
  ];

  const container = "max-w-[1380px] mx-auto px-4 sm:px-6";
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`${removeTopGap ? "mt-0" : "mt-[50px]"} bg-gradient-to-r from-sky-600 to-[#153955] text-white pt-6 md:pt-12`}
      aria-label="Pied de page"
    >
      {/* DESKTOP */}
      <div className={`${container} hidden md:grid grid-cols-2 lg:grid-cols-4 gap-7 md:gap-8 pb-6`}>
        {/* Column 1: À propos + Contact */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">
            <Link to="/fr/a-propos" className="hover:text-sky-300 inline-block">À PROPOS DE NOUS</Link>
          </h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            <li>
              <Link to="/fr/tout-ce-que-nous-vendons" className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded">
                <ArrowRight size={15} /> Nos services
              </Link>
            </li>
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">CONTACT</h3>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-sky-300 shrink-0" />
              <a href="tel:+18444400128" className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded break-all" aria-label="Appeler le +1 (844) 440-0128">
                +1 (844) 440-0128
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-sky-300 mt-1 shrink-0" />
              <a
                href="https://www.google.com/maps?q=9300+Goreway+Drive,+%23106,+Brampton,+ON+L6P+4N1"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded leading-snug"
                aria-label="Ouvrir l'emplacement sur Google Maps"
              >
                9300 Goreway Drive, #106<br />Brampton, ON L6P 4N1
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-sky-300 shrink-0" />
              <a href="mailto:info@einsured.ca" className="hover:text-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-300 rounded break-all" aria-label="Envoyer un courriel à info@einsured.ca">
                info@einsured.ca
              </a>
            </li>
          </ul>
        </div>

        {/* Column 2: Services Vie */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">SERVICES VIE</h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {lifeLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded">
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3: Investissements + Voyage */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">INVESTISSEMENTS</h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {investmentLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded">
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">ASSURANCE VOYAGE</h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {travelLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded">
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 4: Vivant + Ressources + Équipe */}
        <div>
          <h3 className="font-bold mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">PRESTATIONS DU VIVANT</h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            {livingLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded">
                  <ArrowRight size={15} /> {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">RESSOURCES</h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            <li><Link to="/blog" className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"><ArrowRight size={15} /> Blogue</Link></li>
            <li><Link to="/fr/faq" className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"><ArrowRight size={15} /> FAQ</Link></li>
            <li><Link to="/fr/avis" className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"><ArrowRight size={15} /> Avis</Link></li>
            <li><Link to="/fr/etudes-de-cas" className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded"><ArrowRight size={15} /> Études de cas</Link></li>
          </ul>

          <h3 className="font-bold mt-4 md:mt-5 mb-2.5 md:mb-3 text-xs md:text-[15px] tracking-wider">NOTRE ÉQUIPE</h3>
          <ul className="space-y-1 md:space-y-1.5 text-sm">
            <li>
              <Link to="/fr/notre-equipe" className="flex items-center gap-2 hover:text-sky-300 cursor-pointer py-0.5 rounded">
                <ArrowRight size={15} /> Notre équipe
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* MOBILE */}
      <div className={`${container} md:hidden pb-6 space-y-3`}>
        {/* À propos + Contact */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">À PROPOS &amp; CONTACT</span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Appuyer pour développer</span>
              <span className="hidden group-open:inline">Appuyer pour réduire</span>
            </span>
          </summary>
          <div className="mt-3 space-y-4 text-sm">
            <div>
              <p className="font-semibold mb-1 text-[13px] tracking-wider">
                <Link to="/fr/a-propos" className="hover:text-sky-300">À PROPOS DE NOUS</Link>
              </p>
              <ul className="space-y-1.5">
                <li>
                  <Link to="/fr/tout-ce-que-nous-vendons" className="flex items-center gap-2 hover:text-sky-300 py-1 rounded">
                    <ArrowRight size={15} /> Nos services
                  </Link>
                </li>
              </ul>
            </div>
            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-2 text-[13px] tracking-wider">CONTACT</p>
              <ul className="space-y-3">
                <li className="flex items-center gap-2">
                  <Phone size={16} className="text-sky-300 shrink-0" />
                  <a href="tel:+18444400128" className="hover:text-sky-300 break-all" aria-label="Appeler le +1 (844) 440-0128">+1 (844) 440-0128</a>
                </li>
                <li className="flex items-start gap-2">
                  <MapPin size={16} className="text-sky-300 mt-1 shrink-0" />
                  <a href="https://www.google.com/maps?q=9300+Goreway+Drive,+%23106,+Brampton,+ON+L6P+4N1" target="_blank" rel="noopener noreferrer" className="hover:text-sky-300 leading-snug" aria-label="Ouvrir l'emplacement sur Google Maps">
                    9300 Goreway Drive, #106<br />Brampton, ON L6P 4N1
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={16} className="text-sky-300 shrink-0" />
                  <a href="mailto:info@einsured.ca" className="hover:text-sky-300 break-all" aria-label="Envoyer un courriel à info@einsured.ca">info@einsured.ca</a>
                </li>
              </ul>
            </div>
          </div>
        </details>

        {/* Services Vie */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">SERVICES VIE</span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Appuyer pour développer</span>
              <span className="hidden group-open:inline">Appuyer pour réduire</span>
            </span>
          </summary>
          <ul className="mt-3 space-y-1.5 text-sm">
            {lifeLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> {item.label}</Link>
              </li>
            ))}
          </ul>
        </details>

        {/* Investissements + Voyage */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">INVESTISSEMENTS &amp; VOYAGE</span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Appuyer pour développer</span>
              <span className="hidden group-open:inline">Appuyer pour réduire</span>
            </span>
          </summary>
          <div className="mt-3 space-y-4 text-sm">
            <div>
              <p className="font-semibold mb-1 text-[13px] tracking-wider">INVESTISSEMENTS</p>
              <ul className="space-y-1.5">
                {investmentLinks.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> {item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-1 text-[13px] tracking-wider">ASSURANCE VOYAGE</p>
              <ul className="space-y-1.5">
                {travelLinks.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> {item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </details>

        {/* Vivant + Ressources + Équipe */}
        <details className="group bg-white/5 rounded-lg px-4 py-3">
          <summary className="flex justify-between items-center cursor-pointer list-none">
            <span className="font-semibold text-xs tracking-wider">VIVANT + RESSOURCES + ÉQUIPE</span>
            <span className="text-xs text-white/70">
              <span className="group-open:hidden">Appuyer pour développer</span>
              <span className="hidden group-open:inline">Appuyer pour réduire</span>
            </span>
          </summary>
          <div className="mt-3 space-y-4 text-sm">
            <div>
              <p className="font-semibold mb-1 text-[13px] tracking-wider">PRESTATIONS DU VIVANT</p>
              <ul className="space-y-1.5">
                {livingLinks.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> {item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-1 text-[13px] tracking-wider">RESSOURCES</p>
              <ul className="space-y-1.5">
                <li><Link to="/blog" className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> Blogue</Link></li>
                <li><Link to="/fr/faq" className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> FAQ</Link></li>
                <li><Link to="/fr/avis" className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> Avis</Link></li>
                <li><Link to="/fr/etudes-de-cas" className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> Études de cas</Link></li>
              </ul>
            </div>
            <div className="pt-3 border-t border-white/10">
              <p className="font-semibold mb-1 text-[13px] tracking-wider">NOTRE ÉQUIPE</p>
              <Link to="/fr/notre-equipe" className="flex items-center gap-2 hover:text-sky-300 py-1 rounded"><ArrowRight size={15} /> Notre équipe</Link>
            </div>
          </div>
        </details>
      </div>

      {/* Social Icons */}
      <div className="flex flex-wrap justify-center gap-3 sm:gap-4 px-4 pb-4 mb-12">
        <a href="https://www.facebook.com/einsured.ca/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"><Facebook size={18} /></a>
        <a href="https://www.linkedin.com/company/einsured-ca/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"><Linkedin size={18} /></a>
        <a href="https://www.instagram.com/einsured.ca/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"><Instagram size={18} /></a>
        <a href="https://in.pinterest.com/einsuredca/?eq=einsured&etslf=6832" target="_blank" rel="noopener noreferrer" aria-label="Pinterest" className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"><FaPinterest size={18} /></a>
        <a href="mailto:info@einsured.ca" aria-label="Courriel" className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"><Mail size={18} /></a>
        <a href="https://www.youtube.com/@einsured1546" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="bg-white/10 hover:bg-sky-400 text-white p-2.5 rounded-full transition"><Youtube size={18} /></a>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#0a1928] text-center text-xs sm:text-sm py-2 border-t border-white/10 px-4">
        <div className={`${container} flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4`}>
          <p className="opacity-90">Copyright © {currentYear} - Tous droits réservés | einsured.ca.</p>
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            <Link to="/fr/politique-confidentialite" className="hover:text-sky-300">Politique de confidentialité</Link>
            <span className="opacity-40 hidden sm:inline">|</span>
            <Link to="/fr/conditions-utilisation" className="hover:text-sky-300">Conditions générales</Link>
            <span className="opacity-40 hidden sm:inline">|</span>
            <Link to="/fr/faq" className="hover:text-sky-300">FAQ</Link>
            <span className="opacity-40 hidden sm:inline">|</span>
            <Link to="/fr/avertissement" className="hover:text-sky-300">Avertissement</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterFr;
